import { FlashLogState, FlashLogActionTypes, flashLogActionNames } from './types';

const initialState: FlashLogState = {
  flashLogs: undefined,
  isLoading: false
};

export const flashLogReducer = (
  state: FlashLogState = initialState,
  action: FlashLogActionTypes,
): FlashLogState => {
  switch (action.type) {
    case flashLogActionNames.SET_FLASH_LOG_SUMMARIES: {
      return {
        ...state,
        flashLogs: action.payload,
      };
    }
    case flashLogActionNames.SET_IS_LOADING: {
      return {
        ...state,
        isLoading: action.payload
      }
    }
    default:
      return state;
  }
};
